import React from 'react';
import PropTypes from 'prop-types';
import { Divider, List, Segment } from 'semantic-ui-react';
import styles from './DetailSection.module.css';

function DetailSection({ title, headerExtra, items, emptyMessage }) {
  return (
    <Segment className={styles.card}>
      <h3>
        {title}
        {headerExtra && (
          <span style={{ float: 'right', fontWeight: 'normal' }}>
            {headerExtra}
          </span>
        )}
      </h3>
      <Divider fitted />
      <div className={styles['scroll-area']}>
        {items.length === 0 && emptyMessage ? (
          <p>{emptyMessage}</p>
        ) : (
          <List divided relaxed>
            {items.map(({ key, label, value }) => (
              <List.Item key={key}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <strong>{label}</strong>
                  <div>{value}</div>
                </div>
              </List.Item>
            ))}
          </List>
        )}
      </div>
    </Segment>
  );
}

DetailSection.propTypes = {
  title: PropTypes.string.isRequired,
  headerExtra: PropTypes.node,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
  emptyMessage: PropTypes.string,
};

DetailSection.defaultProps = {
  headerExtra: null,
  emptyMessage: null,
};

export default DetailSection;
